import { useUser } from '../../userAccess/useUser';
import { User, UserSite } from '../../userAccess/UserContext';
import { Tooltip, OverlayTrigger } from "react-bootstrap";

export function AdminNavMenu() {
  return (
    <header className="navbar navbar-expand-sm navbar-end navbar-sticky-top navbar-light bg-white">
      <div className="container-fluid">
        <div className="navbar-nav-wrap">
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#sideNavbar" aria-controls="sideNavbar" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-default">
              <i className="bi-list"></i>
            </span>
            <span className="navbar-toggler-toggled">
              <i className="bi-x"></i>
            </span>
          </button>

          <nav className="navbar-nav-wrap-col navbar-collapse">
            <ul className="navbar-nav">
              <AdminMenu />
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}

const AdminMenu = () => {
  const user = useUser();
  const menuText = user ? user.email + (user.selectedSite ? ` : ${user.selectedSite.city + ', ' + user.selectedSite.state}` : '') : '';
  const isSelectedSite = isSiteForId(user.selectedSite?.id);

  return (
      <li className='nav-item dropdown'>
        <OverlayTrigger placement='left' overlay={menuText.length > 50 ? 
            <Tooltip>
              {user.selectedSite ? `${user.selectedSite.city + ', ' + user.selectedSite.state}` : ''}
              <div className="small">{user.selectedSite ? `(${user.selectedSite.business})` : ''}</div>
            </Tooltip> : 
            <span />}>
          <button id='blogMegaMenu' className='nav-link dropdown-toggle btn btn-link pb-0'
            data-bs-toggle='dropdown' aria-expanded='false'>
              {trimToLength(menuText)}
          </button>
        </OverlayTrigger>
        {user.selectedSite?.business && <div className="text-muted small text-end px-5">({trimToLength(user.selectedSite.business, 60)})</div>}
        <div className='dropdown-menu dropdown-nav-menu'>
          <span className='dropdown-header'>Site</span>
          {user.userSites.map(site =>
            <OverlayTrigger placement='left' overlay={(site.city + ', ' + site.state).length > 50 || site.business.length > 60 ? 
                <Tooltip>
                  {site.city + ', ' + site.state}
                  <div className="small">{'(' + trimToLength(site.business, 60) + ')'}</div>
                </Tooltip> : 
                <span />}>
              <button className={'dropdown-item btn btn-link ' + (isSelectedSite(site) ? 'active' : '')}
                key={site.id} onClick={() => user.setSelectedSite(findSiteById(user, site.id))}>
                  {trimToLength(site.city + ', ' + site.state)}
                  <div className="text-muted small">{'(' + trimToLength(site.business, 60) + ')'}</div>
              </button>
            </OverlayTrigger>)}
        <div className='dropdown-divider'></div>
        <button className='dropdown-item btn btn-link' onClick={() => user.signOut()}>Sign Out</button>
      </div>
    </li>
  );
};

const findSiteById = (user: User, siteId: string) =>
  user.userSites.find(isSiteForId(siteId)) ?? null;

const isSiteForId = (id: string | undefined) =>
  (site: UserSite) => site.id.toLowerCase() === id?.toLowerCase();

const trimToLength = (text: string, length: number = 50) => 
  text.length > length ? text.substring(0, length) + '...' : text;
  